import React from 'react';
import { Box, Link, Typography } from '@mui/material';

import BackgroundImage from '../../image/lonely.jpg';

const NotFound = () => {
    const [linearGradient] = React.useState(
        'linear-gradient(to top right, rgba(45, 51, 73, 0.75) 0%, rgba(57, 55, 75, 0.75) 18%, rgba(68, 59, 77, 0.75) 35%, rgba(123, 83, 116, 0.75) 80%, rgba(177, 97, 97, 0.75) 100%)'
    );

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                backgroundImage: `${linearGradient}, url(${BackgroundImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: -50,
            }}
        >
            <Box
                sx={{
                    marginLeft: '10%',
                    paddingTop: '5%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography
                    component="div"
                    sx={{
                        fontSize: 300,
                        fontWeight: 900,
                        fontFamily: 'Arial',
                        color: '#fff',
                        textShadow: 'RGBA(170, 95, 99, 0.38) 20px 30px 15px',
                    }}
                >
                    404
                </Typography>

                <Typography
                    component="div"
                    sx={{
                        fontSize: 44,
                        fontWeight: 700,
                        fontFamily: 'Arial',
                        color: '#fff',
                        textShadow: 'RGBA(170, 95, 99, 0.38) 8px 12px 6px',
                    }}
                >
                    Ooops! Well… this is awkward.
                </Typography>

                <Typography
                    component="div"
                    sx={{
                        fontSize: 22,
                        fontFamily: 'Arial',
                        color: '#fff',
                    }}
                >
                    <Box>It looks like the page you were expecting ghosted you.</Box>
                    <Box>Now, let's go find some better pages that show up when you need them.</Box>
                    <Link
                        sx={{ fontFamily: 'inherit', fontSize: 'inherit', color: '#248FE6' }}
                        href="https://www.duckduckgo.com"
                    >
                        Search for that special webpage
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
};

export default NotFound;
